import { Fragment, type ReactNode } from "react";
import { DOCS, type DocumentKind } from "../lib/legal";

/** A legal document's page on deepthird.com, in a new tab, so a file chosen on the Upload page stays chosen. */
export function DocLink({ kind, children }: { kind: DocumentKind; children?: ReactNode }) {
  return (
    <a className="doc" href={DOCS[kind].url} target="_blank" rel="noreferrer" data-testid={`doc-${kind}`}>
      {children ?? DOCS[kind].title}
    </a>
  );
}

/** Words from packages/legal/manifest.json, each `{beta_terms}` or `{privacy}` a link to that document. */
export function Words({ text }: { text: string }) {
  const parts = text.split(/\{(beta_terms|privacy)\}/);
  return <>{parts.map((p, i) => (i % 2 ? <DocLink key={i} kind={p as DocumentKind} /> : <Fragment key={i}>{p}</Fragment>))}</>;
}
